import { render, staticRenderFns } from "./vip-order-test.vue?vue&type=template&id=75559200&scoped=true&"
import script from "./vip-order-test.vue?vue&type=script&lang=js&"
export * from "./vip-order-test.vue?vue&type=script&lang=js&"
import style0 from "./vip-order-test.vue?vue&type=style&index=0&id=75559200&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75559200",
  null
  
)

export default component.exports